/** Picks v2 or v1 of the Admin create/edit form based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AdminFormPage   from './AdminFormPage';
import AdminFormPageV2 from './v2/AdminFormPageV2';

export default function AdminFormPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AdminFormPageV2 : AdminFormPage;
  return <Component {...props} />;
}
